import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AgrExtendedNotificationModule } from '@next/core-lib/components';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';

@Component({
  selector: 'app-delivery-date-weekend-warning',
  templateUrl: './delivery-date-weekend-warning.component.html',
  imports: [AgrI18nSharedModule, AgrExtendedNotificationModule, CommonModule, MatIconModule],
})
export class DeliveryDateWeekendWarningComponent implements OnInit {
  shouldShowNotification = false;
  readonly friday = 5;
  readonly saturday = 6;
  readonly onePm = 13;
  readonly thirty = 30;
  readonly twoPm = 14;

  ngOnInit(): void {
    const dutchDateTime = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));
    const dutchDay = dutchDateTime.getDay();

    const isPassedFridayOneThirtyPm = dutchDay === this.friday && dutchDateTime.getHours() >= this.onePm && dutchDateTime.getMinutes() >= this.thirty;
    const isBeforeSaturday2Pm = dutchDay === this.saturday && dutchDateTime.getHours() < this.twoPm;

    if (isPassedFridayOneThirtyPm || isBeforeSaturday2Pm) {
      this.shouldShowNotification = true;
    }
  }
}
